import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {campaignPreviewInitialState} from './campaignPreview.config';
import {CampaignPreviewParams} from './campaignPreview.types';
import {DTPreviewMetadata, PreviewStep} from 'common/src/modules/decisionTree/preview.types';

const campaignPreviewSlice = createSlice({
  name: 'campaignPreviewSlice',
  initialState: campaignPreviewInitialState,
  reducers: {
    resetCampaignPreview: () => campaignPreviewInitialState,
    updatePreviewParams: (state, action: PayloadAction<CampaignPreviewParams>) => {
      state.previewParams = action.payload;
    },
    updatePreviewMetaData: (state, action: PayloadAction<DTPreviewMetadata>) => {
      state.previewMeta = action.payload;
    },
    updatePreviewSteps: (state, action: PayloadAction<PreviewStep[]>) => {
      state.previewSteps = action.payload;
    },
    updatePreviewStepsCount: (state, action: PayloadAction<number>) => {
      state.numOfPreviewSteps = action.payload;
    },
    updateHighlightedNodeId: (state, action: PayloadAction<number>) => {
      state.highlightedNodeId = action.payload;
    },
  },
});

const {
  updatePreviewParams,
  resetCampaignPreview,
  updatePreviewMetaData,
  updatePreviewSteps,
  updatePreviewStepsCount,
  updateHighlightedNodeId,
} = campaignPreviewSlice.actions;
export {
  resetCampaignPreview,
  updatePreviewParams,
  updatePreviewMetaData,
  updatePreviewSteps,
  updatePreviewStepsCount,
  updateHighlightedNodeId,
};

export default campaignPreviewSlice.reducer;
